import type { ReactNode } from 'react';
import { VaultNewRecordsContext } from './context';
import { useVaultNewRecords } from './useVaultNewRecords';

/** [MCV-1812] Hosts the provider's New-record marks for the side nav and every vault section. */
export const VaultNewRecordsProvider = ({
  providerId,
  readOnly,
  children,
}: {
  providerId: number | undefined;
  readOnly?: boolean;
  children: ReactNode;
}) => {
  const value = useVaultNewRecords(providerId, { readOnly });
  return (
    <VaultNewRecordsContext.Provider value={value}>{children}</VaultNewRecordsContext.Provider>
  );
};
